module.exports = __webpack_public_path__ + "images/445a8dce9bf70d41381602c82a0e7fe6.png";